import {
  mocDenNgayBienLai,
  mocTuNgayBienLai,
} from "../../../helpers/mocNgayLamMoi";
import { getThuTatCaHkNhSync } from "../../../helpers/thuTatCaConfig";
import { IBienLaiPagingRequest } from "../../../model/request/bien-lai/IBienLaiPagingRequest";
import {
  IBienLaiThuPaging,
  IPagingBienLaiResult,
} from "../../../model/respone/bien-lai/IBienLaiThuPaging";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IBienLaiPagingActionTypes } from "../../action-types/bien-lai/IBienLaiPagingActionTypes";
import { IBienLaiPagingReducer } from "../../reducer-model/bien-lai/IBienLaiPagingReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IBienLaiPagingReducer = {
  bienLais: {} as IPagingBienLaiResult,
  request: {
    id_hes: [],
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    khoa_hocs: [],
    id_khoi_nganhs: [],
    page_index: 0,
    page_size: 100,
    search_key: "",
    id_chuyen_nganhs: [],
    id_khoas: [],
    id_hinh_thuc_thanh_toans: [],
    loai_phieu: "all",
    trang_thai_phieu: "hoan-thanh",
    trang_thai_gui_sms: "all",
    nguoi_thu: "",
    id_cb_thus: [],
    ghi_chu: "",
    search_fields: [],
    id_co_sos: [],
    id_doi_tuongs: [],
    id_ngan_hangs: [],
    id_tai_khoans: [],
    tinh_chat_hocs: [],
    ky_dang_kys: [],
    is_all_hk_namhoc: false,
    filter_phamvi: getThuTatCaHkNhSync() ? "all" : "nam",
    id_nhom_thu_chis: [],
    visible_columns: [],
    trang_thai_hocs: [],
    // Mặc định: TỪ 00:00 hôm nay ĐẾN đúng giờ đang xem — mở màn ra là thấy tiền thu
    // trong ngày, không kéo sang giờ chưa tới.
    // Mốc lấy qua mocNgayLamMoi để nút Làm mới kéo được "đến ngày" tới hiện tại; nếu để
    // formatDateTimeISO(new Date()) thẳng ở đây thì mốc đứng im từ lúc nạp app và phiếu
    // lập sau đó không bao giờ hiện ra.
    tu_ngay: mocTuNgayBienLai.lay() as any,
    den_ngay: mocDenNgayBienLai.lay() as any,
    loc_theo_gio: true,
  } as IBienLaiPagingRequest,
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_not_initialization,
  idShowViewDetail: 0,
  bienLaiHuy: undefined,
  isShowFilter: false,
  idSelections: [],
  isShowDongBoKeToanModal: false,
  cacheIdImport: "",
  isShowImportModal: false,
  isShowImportResultModal: false,
  statusSaveImport: eReducerStatusBase.is_not_initialization,
} as IBienLaiPagingReducer;

export const bienLaiPagingReducer = (
  state: IBienLaiPagingReducer = iniState,
  action: IBienLaiPagingActionTypes,
): IBienLaiPagingReducer => {
  switch (action.type) {
    case "BIEN_LAI_PAGING_LOAD_START":
      return {
        ...state,
        bienLais: {} as IPagingBienLaiResult,
        request: action.payload,
        status: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_PAGING_LOAD_SUCCESS":
      // GIỮ idSelections: đổi trang cũng đi qua đây, xóa ở đây thì tích ở trang 1
      // bay mất khi sang trang 2 (chức năng "Tạo file gửi SMS" cần tích xuyên trang).
      // Nơi PHẢI xóa tích là khi ĐỔI BỘ LỌC — xử lý ở CHANGE_REQUEST bên dưới.
      return {
        ...state,
        bienLais: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_LOAD_ERRR":
      return {
        ...state,
        bienLais: {} as IPagingBienLaiResult,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_CHANGE_REQUEST": {
      // Chỉ paging mới auto-reload. Mọi thay đổi khác (filter/search/sort/scope)
      // chỉ update request, user phải bấm "Làm mới".
      const reloadKeys = ["page_index", "page_size"];
      const keys = Object.keys(action.payload);
      // Chỉ reload khi MỌI key trong payload đều là paging key — tức là user
      // bấm phân trang thuần. Filter có thể kèm page_index: 0 để reset trang
      // nhưng vì có thêm key filter, nên không reload.
      const isReload = keys.length > 0 && keys.every((k) => reloadKeys.includes(k));
      // ĐỔI BỘ LỌC (không phải phân trang thuần) -> tập biên lai thay đổi hẳn, giữ tích cũ
      // sẽ xuất nhầm những dòng người dùng không còn nhìn thấy => xóa tích. Phân trang thì GIỮ.
      return {
        ...state,
        ...(isReload && { status: eReducerStatusBase.is_need_reload }),
        ...(!isReload && { idSelections: [] }),
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    }

    case "BIEN_LAI_PAGING_SHOW_DETAIL_MODAL":
      return {
        ...state,
        idShowViewDetail: action.payload,
      };
    case "BIEN_LAI_PAGING_HIDE_DETAIL_MODAL":
      return {
        ...state,
        idShowViewDetail: 0,
      };
    case "BIEN_LAI_PAGING_HUY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "BIEN_LAI_PAGING_HUY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        bienLaiHuy: undefined,
      };
    case "BIEN_LAI_PAGING_HUY_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "BIEN_LAI_PAGING_SHOW_HUY_MODAL":
      return {
        ...state,
        bienLaiHuy: action.payload,
      };
    case "BIEN_LAI_PAGING_HIDE_HUY_MODAL":
      return {
        ...state,
        bienLaiHuy: undefined,
      };
    case "BIEN_LAI_PAGING_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    case "BIEN_LAI_PAGING_EXPORT_EXCEL_BAO_CAO_START":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_PAGING_EXPORT_EXCEL_BAO_CAO_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_EXPORT_EXCEL_BAO_CAO_ERRR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_START":
      return {
        ...state,
        request: {
          ...state.request,
          mau_so: action.payload.mau_so,
        },
        statusExport: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
        printHtml: action.payload,
      };
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_CLOSE":
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_ERRR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
        printHtml: undefined,
      };
    case "BIEN_LAI_PAGING_CHANGE_CHO_PHEP_XUAT_HD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "BIEN_LAI_PAGING_CHANGE_CHO_PHEP_XUAT_HD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        bienLais: {
          ...state.bienLais,
          data: state.bienLais.data.map((x) => {
            if (x.id_bien_lai === action.payload.id_bien_lai) {
              return {
                ...x,
                is_khong_xuat_hd: action.payload.is_khong_xuat_hd,
              };
            }
            return x;
          }),
        },
      };
    case "BIEN_LAI_PAGING_CHANGE_CHO_PHEP_XUAT_HD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "BIEN_LAI_PAGING_SHOWHIDE_DONG_BO_KE_TOAN_MODAL":
      return {
        ...state,
        isShowDongBoKeToanModal: action.payload,
      };
    case "BIEN_LAI_PAGING_SYNC_KE_TOAN_START":
    case "BIEN_LAI_PAGING_SYNC_KE_TOAN_FAKE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_PAGING_SYNC_KE_TOAN_SUCCESS":
      return {
        ...state,
        isShowDongBoKeToanModal: false,
        idSelections: [],
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_SYNC_KE_TOAN_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };

    case "BIEN_LAI_PAGING_SHOW_HIDE_IMPORT_MODAL":
      return {
        ...state,
        isShowImportModal: action.payload,
      };
    case "BIEN_LAI_PAGING_IMPORT_START": {
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    }
    case "BIEN_LAI_PAGING_IMPORT_SUCESS": {
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        bienLaiImports: action.payload.data,
        cacheIdImport: action.payload.cache_id,
        isShowImportModal: false,
        isShowImportResultModal: true,
      };
    }
    case "BIEN_LAI_PAGING_IMPORT_ERROR": {
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    }
    case "BIEN_LAI_PAGING_HIDE_IMPORT_RESULT_MODAL": {
      return {
        ...state,
        isShowImportResultModal: false,
      };
    }
    case "BIEN_LAI_PAGING_SAVE_IMPORT_START": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_saving,
        saveImportProcessId: action.payload.process_id,
        isShowSaveImportProcessing: true,
      };
    }
    case "BIEN_LAI_PAGING_SAVE_IMPORT_SUCESS": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_saved,
        status: eReducerStatusBase.is_need_reload,
        isShowImportResultModal: false,
        bienLaiImports: undefined,
        cacheIdImport: "",
        bienLaiImportSelected: [],
      };
    }
    case "BIEN_LAI_PAGING_SAVE_IMPORT_ERROR": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_completed,
        isShowSaveImportProcessing: false,
      };
    }
    case "BIEN_LAI_PAGING_CLOSE_SAVE_IMPORT_PROCESSING_MODAL": {
      return {
        ...state,
        isShowSaveImportProcessing: false,
      };
    }
    default:
      return state;
  }
};
